// extracted by mini-css-extract-plugin
export default {"dropdown":"styled_dropdown__cwuFz","empty":"styled_empty__3P7L5"};